import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {RecordsDataRequestQueryParams} from "../../../../../core/types/records-table.types";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../../core/constants/base-url";

@Injectable({
  providedIn: 'root'
})
export class PulseReportChartApiService {
  private http: HttpClient = inject(HttpClient);

  public getRecordTableChartData(path: string, queryParams: RecordsDataRequestQueryParams): Observable<any> {
    return this.http.get<any>(`${baseUrl}/${path}/charts`, {
      params: queryParams
    });
  }
}
